import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material';
import { CssBaseline } from '@mui/material';
import App from './App';
import './css/fonts.css';

const theme = createTheme({
  // You can customize your theme here using your styleguide values
  palette: {
    mode: 'light',
    primary: {
      main: 'rgba(233, 80, 95, 1)', // --primary-colorscalypso-coral
    },
  },
  typography: {
    fontFamily: '"Satoshi-Regular", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);